import React, { useState, useCallback } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  Aggregation, AggregationInterval, ArgumentAxis,
  TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';
import {SIFReportingCompanies, SIFFilter} from '../'

export default function SIFEventsAndInjuries(props) {
  const [data, setData] = useState();

  const calculateCount = useCallback((aggregationInfo) => {
    if (!aggregationInfo.data.length) {
      return null;
    }

    var fat = 0;
    var inj = 0;
    var cnt = 0;
    for (var i=0; i< aggregationInfo.data.length; i++) {
      fat = fat + (parseInt(aggregationInfo.data[i]['Number of Fatalities']) || 0)
      inj = inj + (parseInt(aggregationInfo.data[i]['Number of Serious Injuries']) || 0)
      if ((parseInt(aggregationInfo.data[i]['Number of Fatalities']) || 0)+(parseInt(aggregationInfo.data[i]['Number of Serious Injuries']) || 0) === 0) {
        cnt = cnt + 1;
      }
      /*if (aggregationInfo.data[i]['Potential or Actual SIF'] === "Actual") {
        fat = fat + (parseInt(aggregationInfo.data[i]['Number of Fatalities']) || 0)
        inj = inj + (parseInt(aggregationInfo.data[i]['Number of Serious Injuries']) || 0)
      } else {
        cnt = cnt + 1;
      }*/
    }
    return {
      'DATE OF EVENT (m/d/yyyy)': aggregationInfo.intervalStart,
      injuries: inj,
      fatalities: fat,
      count: cnt,
    };
  }, []);

  const onFilterDataChanged = useCallback((data) => {
    setData([...data]);
  }, []);

  const customizeTooltip = useCallback((pointInfo) => {
    const month = pointInfo.argument.toLocaleString('default', { month: 'long' , year: 'numeric'});
    var txt = ''
    txt = `<div><div class="tooltip-header">${month}</div><div class="tooltip-body">`
    txt = txt+`<div>${pointInfo.seriesName}: ${pointInfo.value}</div>`
    txt=txt+`</div></div>`
    return {
      html: txt,
    }
  }, []);

  return (
    <div>
      <SIFFilter
        data={props.data}
        startDate={props.startDate}
        endDate={props.endDate}
        onFilteredDataChanged={onFilterDataChanged}
        showArea={true}
        showDisciplines={true}
        showActivities={true}
        showPrimaryFactor={true}
        showCategories={true}
      />
      <Chart
        id="chart"
        dataSource={data}
        title='Events, Injuries and Fatalities Over Time'
      >
        <ArgumentAxis aggregatedPointsPosition="crossTicks">
          <AggregationInterval months={1} />
          <TickInterval months={1} />

          />
        </ArgumentAxis>
        <CommonSeriesSettings
          argumentField="DATE OF EVENT (m/d/yyyy)"

        >
          <Aggregation
            enabled={true}
            calculate={calculateCount}
            method="custom"
          />
        </CommonSeriesSettings>
        <Series
          type="spline"
          valueField="count"
          name="Events(Potential or Not Specified)"
          color="#144c6d"
        >
        </Series>
        <Series
          type="bar"
          valueField="injuries"
          name="Serious Injuries"
          color="rgba(236, 80, 32, 0.3)"
        >
        </Series>
        <Series
          type="bar"
          valueField="fatalities"
          name="Fatalities"
          color="rgba(236, 80, 32, 1)"
        >
        </Series>
        <ValueAxis showZero={false} />
        <Legend visible={true} />
        <Tooltip
          enabled={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>

      <SIFReportingCompanies data={data}/>

    </div>
  );
}
